<template>
    <div>
        <v-list class="hidden-xs-only product-list product-list-pf no-padding-top margin-right-xl bg-color">
            <v-list-tile class="product-item margin-bottom-s padding-left-s padding-right-s bg-color-lightest" avatar v-for="product in products" :key="product.code" >
                <v-list-tile-avatar>
                    <choose-product-svg v-if="product.productStatusType === 'ACTIVE'" class="product_icon"></choose-product-svg>
                    <choose-product-svg v-else class="product_icon product_icon_disabled"></choose-product-svg>
                </v-list-tile-avatar>
                <v-list-tile-content v-if="product.productStatusType === 'ACTIVE'">
                    <v-list-tile-title  class="color-headings-text font-weight-regular">
                        {{ product.name }}
                    </v-list-tile-title>
                </v-list-tile-content>

                    <v-list-tile-content v-else>
                    <v-list-tile-title  class="no-product-active font-weight-regular">
                        {{ product.name }}
                    </v-list-tile-title>
                        <v-list-tile-sub-title v-if="product.productStatusType === 'NOT_YET_ACTIVE'" class="no-active-product">{{text('api.error.product.activation.period.not.started', [product.productStatusDate])}}<</v-list-tile-sub-title>
                        <v-list-tile-sub-title v-if="product.productStatusType === 'EXPIRED'" class="no-active-product">{{text('api.error.product.activation.period.expired', [product.productStatusDate])}}</v-list-tile-sub-title>
                        <v-list-tile-sub-title v-if="product.productStatusType === 'UNRELEASED'" class="no-active-product">{{text('api.error.product.not.released', [product.productStatusDate])}}</v-list-tile-sub-title>
                        <v-list-tile-sub-title v-if="product.productStatusType === 'USER_DEACTIVATED'" class="no-active-product">{{text('api.error.product.activation.period.expired', [product.productStatusDate])}}</v-list-tile-sub-title>
                    </v-list-tile-content>


                <v-list-tile-action v-if="product.productStatusType === 'ACTIVE'" @click="handleClickProduct(product.code)">
                    <v-btn round outline  ripple  class="btn-start-assessment color-primary">{{text('api.button.startAssessment')}}</v-btn>
                </v-list-tile-action>
                    <v-list-tile-action v-else class="no-active-product">
                    </v-list-tile-action>

            </v-list-tile>
        </v-list>

        <v-list class="hidden-sm-and-up product-list product-list-pf no-padding-top margin-right-xl bg-color">
            <v-list-tile class="product-item padding-left-s bg-color-lightest" avatar v-for="product in products" :key="product.code" >
                <v-list-tile-content v-if="product.productStatusType === 'ACTIVE'" @click="handleClickProduct(product.code)">
                    <v-list-tile-title  class="color-headings-text font-weight-regular">
                        {{ product.name }}
                    </v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-content v-else>
                    <v-list-tile-title  class="no-product-active font-weight-regular">
                        {{ product.name }}
                    </v-list-tile-title>
                    <v-list-tile-sub-title v-if="product.productStatusType === 'NOT_YET_ACTIVE'" class="no-active-product">{{text('api.error.product.activation.period.not.started', [product.productStatusDate])}}<</v-list-tile-sub-title>
                    <v-list-tile-sub-title v-if="product.productStatusType === 'EXPIRED'" class="no-active-product">{{text('api.error.product.activation.period.expired', [product.productStatusDate])}}</v-list-tile-sub-title>
                    <v-list-tile-sub-title v-if="product.productStatusType === 'UNRELEASED'" class="no-active-product">{{text('api.error.product.not.released', [product.productStatusDate])}}</v-list-tile-sub-title>
                    <v-list-tile-sub-title v-if="product.productStatusType === 'USER_DEACTIVATED'" class="no-active-product">{{text('api.error.product.activation.period.expired', [product.productStatusDate])}}</v-list-tile-sub-title>
                </v-list-tile-content>

            </v-list-tile>
        </v-list>
    </div>
</template>

<!-- ################################################################## -->

<script>
    import {mapGetters} from 'vuex';
    import chooseProductSvg from "../../../common/components/svg/productList/chooseProduct";

    export default {
        name: 'ProductList',
        components: {
            chooseProductSvg
        },

        computed: mapGetters({
            products: 'PfProductListStore/getProductList'
        }),

        methods: {
            // Component methods.
            handleClickProduct (productCode) {
                this.$emit('onClickProduct', productCode);

                this.$store.commit('PfEvaluationStore/setUsedShortcut', false);
            }
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .home-container.container.grid-list-xl {

        .body-home {

            margin-bottom: -60px;

            .product_icon {
                width: 30px;
            }
        }
    }

    .product-list {

        li, .product-item {
            border-radius: 5px;
        }
    }

    .container.grid-list-xl .activate-product{

        button {
            text-transform: none;
            @include border-radius(4px);

        }
    }

    .btn-start-assessment {
        border-color: $color-element-outline;
    }

    .icon-start-assessment {
        font-size: 36px;
    }


    @media only screen and (max-width: 600px) {
        .product-list.product-list-pf {
            li {
                    border-radius: 10px !important;
                    border: 1px solid lightgray;
                    margin: 0 5px 7px;
            }

        }

    }

</style>




// WEBPACK FOOTER //
// src/pathfinder/components/shared/ProductList.vue